$(document).on('turbolinks:load', function(){
  $(document).on('ajax:error', '#public_careers_search_form', function() {
    window.location.href = "/429.html";
  });
}); 